import React from 'react'
import { BoreholeFieldDefinitionsProps } from '../../system-container/borehole-field/BoreholeFieldDefinitions'
import { BoreholeField } from '../../system-container/borehole-field/BoreholeField'
import { EnergyBusCalculator } from '../../../calculators/EnergyBusCalculator'
import { EnergyBusResultKey } from '../../../provider/result-categories'

type Props = BoreholeFieldDefinitionsProps & {
  energyBusCalculator: EnergyBusCalculator
}

export function EnergyBusBoreholeField({
  container,
  updateContainer,
  energyBusCalculator,
}: Props): React.ReactElement {
  const results = energyBusCalculator.getResultValues()

  const harvested = results[EnergyBusResultKey.HeatFromEnvironment]
  const wasteInput = results[EnergyBusResultKey.HeatToEnvironment]

  return (
    <BoreholeField
      container={container}
      updateContainer={updateContainer}
      harvested={harvested}
      wasteInput={wasteInput}
    />
  )
}
